import Scrollbar from "../../../src/scripts/helpers/scrollbarWidth";

const MOBILE_BREAKPOINT = 1200;

export default class Header {
	static init() {
		// scrollbar with detection
		new Scrollbar();

		// init navigation
		new Header(document.querySelector('.header'), document.querySelector('.search-modal'));
	}

	constructor(element, modalSearch) {
		if(!element) {
			return;
		}
		this.header = element;
		this.navigation = element.querySelector('.navigation');
		this.toggleButton = element.querySelector('.navigation__btn-toggle');
		this.modalSearch = modalSearch;
		this.isNavigationOpen = false;
		this.sublevelOpenTimeout = null;
		this.isMobileViewport = window.innerWidth < MOBILE_BREAKPOINT;
		this.resizeFrame = null;

        const transparencyBreakpoint = parseInt(element.dataset.transparencyBreakpoint) / 1080 * window.innerHeight || 10;

		window.addEventListener('scroll', () => requestAnimationFrame(() => {
			element.classList[window.scrollY < transparencyBreakpoint ? 'remove' : 'add']('header--is-scrolled');
		}));
		element.classList[window.scrollY < transparencyBreakpoint ? 'remove' : 'add']('header--is-scrolled');

		window.addEventListener('resize', () => {
			if (this.resizeFrame) {
				window.cancelAnimationFrame(this.resizeFrame);
			}

			this.resizeFrame = window.requestAnimationFrame(() => {
				this.handleResize();
				this.resizeFrame = null;
			});
		});

		this.setTabIndexes();

		window.addEventListener('click', (e) => {
			const target = e.target;
			const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
			const menu = this.navigation.querySelector('.navigation__menu:not(.navigation__menu--with-actions)');
			const menuLink = target.closest('.navigation__menu-link');
			const menuBackButton = target.closest('.navigation__btn-back');
			const menuItem = menuLink ? menuLink.parentElement : false;
			const menuDropdown = menuItem ? this.getSubmenu(menuItem) : false;
			const menuContainer = menuItem ? this.getMenuContainer(menuItem) : false;
			const menuPanel = menuItem ? this.getDropdownPanel(menuItem) : false;
			const menuColumn = menuItem ? menuItem.closest('.navigation__menu-dropdown__column') : false;
			const isMenuItemActive = menuItem && menuItem.classList.contains('navigation__menu-item--active');
			const menuSearchButton = target.closest('.navigation__menu-link--search') ?? false;
			const modalSearchBackdrop = target.classList.contains('search-modal__backdrop') ? target : false;
			const modalSearchCloseButton = target.classList.contains('search-modal__close-button') ? target : false;
			const toggleButton = target.closest('.navigation__btn-toggle');
			const header = target.classList.contains('header') ? target : false;

			const subToggle = target.closest('.navigation__menu-sub-toggle');
			if (subToggle) {
				e.preventDefault();
				e.stopPropagation();
				const parentLi = subToggle.closest('.navigation__menu-item--has-children');
				if (parentLi) {
					const expanded = parentLi.classList.toggle('is-expanded');
					subToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
				}
				return;
			}

			if (menuItem && menuDropdown) {
                if (isMobile) {
					e.preventDefault();
					if (menuContainer && menuContainer.classList.contains('navigation__menu-sublevel-list')) {
						this.resetSublevelState(menuPanel);

						if (!isMenuItemActive) {
							menuItem.classList.add('navigation__menu-item--sublevel-opening');

							this.sublevelOpenTimeout = window.setTimeout(() => {
								menuContainer.classList.add('navigation__menu-sublevel-list--open');
								menuPanel && menuPanel.classList.add('navigation__menu-dropdown--sublevel-open');
								menuColumn && menuColumn.classList.add('navigation__menu-dropdown__column--active-sublevel');
								menuItem.classList.remove('navigation__menu-item--sublevel-opening');
								menuItem.classList.add('navigation__menu-item--active');
								this.sublevelOpenTimeout = null;
							}, 180);
						}
					} else {
                    	menuItem.classList[isMenuItemActive ? 'remove' : 'add']('navigation__menu-item--active');
                    	menuContainer.classList[isMenuItemActive ? 'remove' : 'add']('navigation__menu--open');
					}
                }
			}

			if (menuBackButton) {
				this.goBack();
			}

			if (menuSearchButton) {
				this.modalSearch.classList.add('search-modal--open');
				this.modalSearch.querySelector('[type="search"]').focus();
			}

			if (modalSearchBackdrop || modalSearchCloseButton) {
				this.modalSearch.querySelector('.search-modal__form').reset();
				this.modalSearch.classList.remove('search-modal--open');
			}

			if (toggleButton) {
				this.toggleMenu();
			}

			if (header) {
				this.closeMenu();
			}
		});
	}

	getSubmenu(menuItem) {
		return Array.prototype.find.call(
			menuItem.children,
			(child) => child.classList && (child.classList.contains('navigation__menu-dropdown') || child.classList.contains('navigation__menu-sublevel'))
		) || false;
	}

	getMenuContainer(menuItem) {
		return menuItem.closest('.navigation__menu-sublevel-list') || menuItem.closest('.navigation__menu');
	}

	getDropdownPanel(menuItem) {
		return menuItem.closest('.navigation__menu-dropdown');
	}

	resetSublevelState(scope = this.navigation) {
		if (this.sublevelOpenTimeout) {
			window.clearTimeout(this.sublevelOpenTimeout);
			this.sublevelOpenTimeout = null;
		}
		Array.prototype.forEach.call(scope.querySelectorAll('.navigation__menu-sublevel-list--open'), el => {
			el.classList.remove('navigation__menu-sublevel-list--open');
		});
		Array.prototype.forEach.call(scope.querySelectorAll('.navigation__menu-dropdown--sublevel-open'), el => {
			el.classList.remove('navigation__menu-dropdown--sublevel-open');
		});
		Array.prototype.forEach.call(scope.querySelectorAll('.navigation__menu-dropdown__column--active-sublevel'), el => {
			el.classList.remove('navigation__menu-dropdown__column--active-sublevel');
		});
		Array.prototype.forEach.call(scope.querySelectorAll('.navigation__menu-sublevel-list .navigation__menu-item--sublevel-opening'), el => {
			el.classList.remove('navigation__menu-item--sublevel-opening');
		});
		Array.prototype.forEach.call(scope.querySelectorAll('.navigation__menu-sublevel-list .navigation__menu-item--active'), el => {
			el.classList.remove('navigation__menu-item--active');
		});
	}

	closeMenu() {
		const scrollTop = parseInt(document.body.style.top || '0', 10);

		this.toggleButton.classList.remove('navigation__btn-toggle--is-active');
		this.navigation.classList.remove('navigation--is-active');
		document.body.classList.remove('menu-open');
		window.scrollTo(0, Number.isNaN(scrollTop) ? 0 : scrollTop * -1);
		document.body.style.top = 'auto';
		this.isNavigationOpen = false;
	}

	openMenu() {
		this.toggleButton.classList.add('navigation__btn-toggle--is-active');
		this.navigation.classList.add('navigation--is-active');
		document.body.classList.add('menu-open');
		this.isNavigationOpen = true;
	}

	toggleMenu() {
		this.isNavigationOpen ? this.closeMenu() : this.openMenu();
	}

	hideAll() {
		this.resetSublevelState();
		Array.prototype.forEach.call(this.navigation.querySelectorAll('.navigation__menu-item--active'), el => {
			el.classList.remove('navigation__menu-item--active');
		});
		this.navigation.querySelector('.navigation__menu:not(.navigation__menu--with-actions)').classList.remove('navigation__menu--open');
	}

	handleResize() {
		const isMobileViewport = window.innerWidth < MOBILE_BREAKPOINT;

		if (isMobileViewport === this.isMobileViewport) {
			return;
		}

		this.isMobileViewport = isMobileViewport;
		this.hideAll();
		this.closeMenu();

		Array.prototype.forEach.call(this.navigation.querySelectorAll('.is-visible'), el => {
			el.classList.remove('is-visible');
		});
		Array.prototype.forEach.call(this.navigation.querySelectorAll('.is-expanded'), el => {
			el.classList.remove('is-expanded');
		});
		Array.prototype.forEach.call(this.navigation.querySelectorAll('.navigation__menu-sub-toggle[aria-expanded="true"]'), el => {
			el.setAttribute('aria-expanded', 'false');
		});
	}

	goBack() {
		const openSublevels = this.navigation.querySelectorAll('.navigation__menu-sublevel-list--open');
		if (openSublevels.length > 0) {
			const openSublevel = openSublevels[openSublevels.length - 1];
			const activeMenuItem = openSublevel.querySelector('.navigation__menu-item--active');
			const openSublevelDropdown = openSublevel.closest('.navigation__menu-dropdown');
			const openSublevelColumn = openSublevel.closest('.navigation__menu-dropdown__column');

			openSublevel.classList.remove('navigation__menu-sublevel-list--open');
			openSublevelDropdown && openSublevelDropdown.classList.remove('navigation__menu-dropdown--sublevel-open');
			openSublevelColumn && openSublevelColumn.classList.remove('navigation__menu-dropdown__column--active-sublevel');
			activeMenuItem && activeMenuItem.classList.remove('navigation__menu-item--active');
			return;
		}

		this.hideAll();
	}

	setTabIndexes() {
		let counter = 1;
		let appsMenuItems = this.navigation.querySelectorAll('.navigation__menu-wrapper + .navigation__menu-wrapper .navigation__menu > .navigation__menu-item');
		Array.prototype.forEach.call(appsMenuItems, (el) => {
			let submenu = el.querySelector('.navigation__menu-dropdown');

			if (submenu) {
				let menuItem = el.querySelector('.navigation__menu-link a')

				if (!menuItem) return;
				menuItem.setAttribute('tabindex', ('' + counter));
				counter++;

				let submenuItems = submenu.querySelectorAll('.navigation__menu-link')
				Array.prototype.forEach.call(submenuItems, (_el) => {
					_el.setAttribute('tabindex', ('' + counter));
					counter++;

					_el.addEventListener("blur", function () {
						_el.parentElement.parentElement.parentElement.classList.remove('is-visible');
					});

					_el.addEventListener("focus", function () {
						_el.parentElement.parentElement.parentElement.classList.add('is-visible');
					});
				});
			} else {
				let menuItem = el.querySelector('a.navigation__menu-link');

				if (!menuItem) return;
				menuItem.setAttribute('tabindex', ('' + counter));
				counter++;
			}
		});
	}
}
